export const MOBILE_PORTRAIT: string = `(max-width: 46.24em) and (orientation: portrait)`;
